/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks if 'value' is a function.
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if 'value' is a function, else returns false.
 * @example
 *
 * isFunction(function test() {
 *   return 'This is test function.';
 * });
 * // -> true
 *
 * isFunction('This is a test function.');
 * // -> false
 */
export const isFunction = (value) => {
  var tag = Object.prototype.toString.call(value);
  var asyncTag = '[object AsyncFunction]';
  var funcTag = '[object Function]';
  var genTag = '[object GeneratorFunction]';
  return tag === asyncTag || tag === funcTag || tag === genTag;
};
